import React, {useEffect, useRef, useState} from "react";
import {Box, Grid, InputAdornment, TextField, Typography} from "@material-ui/core";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {CashGroupService} from "./CashGroupService";
import searchIcon from "../../assets/images/search-normal.svg";
import {
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate
} from "../../utils/numberConvertor";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import {convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";
import useDraggableScroll from "use-draggable-scroll";
import cash from "../Dashboard/image/user.svg";
import {
    RaikoButtonPrimary,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoDatePicker
} from "@moeindal/base-raiko-panel-components";

let page = 0
const CashGroupReport = () => {

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});

    const [numberOfLoans, setNumberOfLoans] = useState("");
    const [summationOfDepositAccountsBalance, setSummationOfDepositAccountsBalance] = useState("");
    const [summationOfLoans, setSummationOfLoans] = useState("");
    const [summationOfPaidInstallment, setSummationOfPaidInstallment] = useState("");


    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CashGroupService(fundID, token, snackbar, loading)

    const [itemCount, setItemCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [groupList, setGroupList] = useState([]);

    const [filterStartDate, setFilterStartDate] = useState("");
    const [filterEndDate, setFilterEndDate] = useState("");
    const [filterGroupName, setFilterGroupName] = useState("");
    const [filterGroupCode, setFilterGroupCode] = useState("");

    useEffect(() => {
        if (filterStartDate.length === 10 && filterEndDate.length === 10) {
            getDataFromServer()
        }
    }, [filterStartDate, filterEndDate])


    function getDataFromServer(
        startDate = filterStartDate,
        endDate = filterEndDate,
        name = filterGroupName,
        code = filterGroupCode
    ) {
        if (startDate.length === 10 && endDate.length === 10) {
            loading(setLoadingStateDispatch(true))
            getSummationReports(
                startDate,
                endDate,
                name,
                code
            )

            service.getGroupReport(
                fundID,
                startDate,
                endDate,
                name,
                code,
                page
            ).then(response => {

                setItemCount(response.numberOfInstallments)
                setPageCount(response.totalPage)
                setTableData(response.data)

                loading(setLoadingStateDispatch(false))

            }).catch(reject => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت گزارش گروه!"))
                loading(setLoadingStateDispatch(false))
            })
        }
    }

    function getSummationReports(
        startDate,
        endDate,
        name,
        code
    ) {
        service.getGroupReportSummation(
            fundID,
            startDate,
            endDate,
            name,
            code
        ).then(response => {
            setNumberOfLoans(response.numberOfLoans)
            setSummationOfDepositAccountsBalance(response.summationOfDepositAccountsBalance)
            setSummationOfLoans(response.summationOfLoans)
            setSummationOfPaidInstallment(response.summationOfPaidInstallment)
        }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت خلاصه گزارش گروه."))
        })
    }

    function setTableData(data) {
        setGroupList([])
        data.map((item, index) => {
            setGroupList(prevState => [...prevState, {
                ...item,
                number: (page * 15) + index + 1,
                createdDate: convertUniversalDateToPersianDate(item.createdAt),
                numberOfLoans: convertCurrencyFormatPositiveNegative(item.numberOfLoans),
                cash: convertCurrencyFormatPositiveNegative(item.summationOfDepositAccountsBalance),
                cashNewAccounts: convertCurrencyFormatPositiveNegative(item.numberOfOpenedDepositAccount),
                cashExitAccounts: convertCurrencyFormatPositiveNegative(item.numberOfClearedDepositAccount),
                summationOfLoans: convertCurrencyFormatPositiveNegative(item.summationOfLoans),
                loanAmount: convertCurrencyFormatPositiveNegative(item.summationOfPaidInstallment),
                state: item.enabled ?
                    <span className="bg_active_state">فعال</span> :
                    <span className="bg_deActive_state">غیرفعال</span>,
            }])
        })

    }

    function handleChange(event, value) {
        page = value - 1
        getDataFromServer()
    }

    return (
        <section className={'pageContainer'} style={{overflowY: 'hidden'}}>
            <Box className="d-flex flex-row w-100"
                 sx={{
                     margin: '1rem 0 1.2rem 0',
                     justifyContent: 'center',
                     alignContent: 'center',
                     alignItems: 'center'
                 }}>
                <section className='d-flex flex-column flex-nowrap flex-grow-1'
                         style={{alignItems: 'baseline'}}>
                    <Typography variant={"h5"}>
                        گزارش گروه ها
                    </Typography>
                    {itemCount > 0 ?
                        <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                            {" " + itemCount + "  گروه"}
                        </Typography> :
                        ''}
                </section>
            </Box>
            <section className="asset-container hideScroll" ref={ref} onMouseDown={onMouseDown}>
                <section className="asset-content-division">
                    <span className="asset-title">تعداد وام ها</span>
                    <span className="asset-details"
                          dir="ltr">{convertCurrencyFormatPositiveNegative(numberOfLoans)}</span>
                    <span className="asset-currency">عدد</span>
                </section>

                <section className="asset-content-division">
                    <span className="asset-title">مجموع پس انداز</span>
                    <span
                        className="asset-details">{convertCurrencyFormatPositiveNegative(summationOfDepositAccountsBalance)}</span>
                    <span className="asset-currency">ریال</span>
                </section>

                <section className="asset-content-division">
                    <span className="asset-title">مجموع وام ها</span>
                    <span
                        className="asset-details">{convertCurrencyFormatPositiveNegative(summationOfLoans)}</span>
                    <span className="asset-currency">ریال</span>
                </section>

                <section className="asset-content-division">
                    <span className="asset-title">مجموع اقساط پرداخت شده</span>
                    <span
                        className="asset-details">{convertCurrencyFormatPositiveNegative(summationOfPaidInstallment)}</span>
                    <span className="asset-currency">ریال</span>
                </section>

            </section>

            <Box className="w-100 mt-2" sm={12}>
                <Grid className="d-flex flex-row flex-wrap flex-grow-1 w-100" sm={12}>

                    <Grid sm={6} md={3} lg={3} xl={3} className='modalTextFieldContainer'>
                        <TextField
                            value={convertToBirthDate(filterStartDate)}
                            onChange={e => {
                                const _date = convertToBirthDate(e.target.value)
                                setFilterStartDate(_date)
                            }}
                            className='w-100'
                            variant="outlined" label="تاریخ شروع *"
                        />

                    </Grid>

                    <Grid sm={6} md={3} lg={3} xl={3} className='modalTextFieldContainer'>
                        <TextField
                            value={convertToBirthDate(filterEndDate)}
                            onChange={e => {
                                const _date = convertToBirthDate(e.target.value)
                                setFilterEndDate(_date)
                            }}
                            className='w-100'
                            variant="outlined" label="تاریخ پایان *"
                        />
                    </Grid>


                    <Grid sm={6} md={3} lg={3} xl={3} xs={12} className='modalTextFieldContainer'>
                        <TextField
                            value={filterGroupName}
                            onChange={e => {
                                const _name = e.target.value
                                setFilterGroupName(_name)
                                getDataFromServer(filterStartDate, filterEndDate, _name)
                            }}
                            className='w-100'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو بر اساس نام گروه"
                            placeholder="نام گروه"/>
                    </Grid>

                    <Grid sm={6} md={3} lg={3} xl={3} xs={12} className='modalTextFieldContainer'>
                        <TextField
                            value={filterGroupCode}
                            onChange={e => {
                                const _code = e.target.value
                                setFilterGroupCode(_code)
                                getDataFromServer(filterStartDate, filterEndDate, filterGroupName, _code)
                            }}
                            className='w-100'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو بر اساس کد گروه"
                            placeholder="کد گروه"/>
                    </Grid>
                </Grid>
                <CustomTable
                    header={columns}
                    data={groupList}
                    rowClicked={_ => {
                    }}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </Box>
        </section>
    )
}

export default CashGroupReport;

const columns = [
        {
            id: 'number',
            label: '#',
            align: 'right',
        },
        {
            id: 'name',
            label: 'نام',
            align: 'right',
        },
        {
            id: 'code',
            label: 'کد گروه',
            align: 'right',
        },
        {
            id: 'cash',
            label: 'مجموع پس انداز (ریال)',
            align: 'right',
        },
        {
            id: 'cashNewAccounts',
            label: 'حساب جدید',
            align: 'right',
        },
        {
            id: 'cashExitAccounts',
            label: 'حساب بسته شده',
            align: 'right',
        },
        {
            id: 'numberOfLoans',
            label: 'تعداد وام ها',
            align: 'right',
        },
        {
            id: 'summationOfLoans',
            label: 'مجموع وام ها',
            align: 'right',
        },
        {
            id: 'loanAmount',
            label: 'مجموع اقساط پرداخت شده (ریال)',
            align: 'right',
        },
        {
            id: 'createdDate',
            label: 'تاریخ ساخت',
            align: 'right',
        },
        {
            id: 'state',
            label: 'وضعیت',
            align: 'right',
        },
    ]
;